import React, { useContext, useState } from 'react'
import axios from 'axios'
import { 
  Container,
  CancelButton,
  SaveButtonDiv,
  SaveButtonImage,
  SaveButtonText,
  LoadingMessage,
  WarningDiv,
  WarningText
} from './style'
import ParametersContext, { ParamObject, StructureObject } from '../../../../contexts/ParametersContext'
import save from '../../../../assets/certificates/AddParameter/save.svg'
import SectionContext from '../../../../contexts/SectionContext'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import { useNavigate } from 'react-router-dom'

const AddParamButtonsDiv: React.FC = () => {
  const { structures, setStructures, mainFields, setMainFields, parameters, editParameterIndex } = useContext(ParametersContext)
  const { certificatesSection, setCertificatesSection } = useContext(SectionContext)
  const { setFeedback } = useContext(FeedbackContext)
  const navigate = useNavigate()

  const handleCancel = () => {
    setStructures([])
    setMainFields({
      name: '',
      paramClass: '',
      family: '',
      type: {id: 0, typeName: ''},
      astm: '',
      uns: '',
      din: '',
      aisi: '',
      others: ''
    })
    navigate('../')
  }

  const handleSubmit = (repeatedName: boolean) => {
    if(mainFields.name === ''){
      return
    }
    if (repeatedName){
      return
    }
    if (certificatesSection === 'newParameter'){
      handleNewParameterSubmit()
    } else {
      handleEditParameterSubmit()
    }
  }

  const parametersToBeCompared = [...parameters]
  if (certificatesSection === 'editParameter'){
    parametersToBeCompared.splice(editParameterIndex, 1)
  }
  const repeatedName = parametersToBeCompared.some(parameter => parameter.name === mainFields.name)

  const handleNewParameterSubmit = () => {
    const newParam: ParamObject = {
      name: mainFields.name,
      paramClass: mainFields.paramClass,
      family: mainFields.family,
      type: mainFields.type,
      astm: mainFields.astm,
      uns: mainFields.uns,
      din: mainFields.din,
      aisi: mainFields.aisi,
      others: mainFields.others,
      structuresArray: structures
    }

    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL

    axios
      .post(`${certificateUrl}/param`, newParam)
      .then((response) => {
        // setStock(response.data)
        setFeedback({
          isOpen:true,
          message:'Sucesso ao criar parâmetro',
          statusOk:true
        })
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      })
      .catch((error) => {
        setFeedback({
          isOpen:true,
          message:'Erro ao criar parâmetro',
          statusOk:false
        })
        console.log(error)
      })
  }

  const handleEditParameterSubmit = () => {
    const newParam: ParamObject = {
      id: mainFields.id,
      name: mainFields.name,
      paramClass: mainFields.paramClass,
      family: mainFields.family,
      type: mainFields.type,
      astm: mainFields.astm,
      uns: mainFields.uns,
      din: mainFields.din,
      aisi: mainFields.aisi,
      others: mainFields.others,
      structuresArray: structures
    }

    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL

    axios
      .put(`${certificateUrl}/param`, newParam)
      .then((response) => {
        setFeedback({
          isOpen:true,
          message:'Sucesso ao salvar parâmetro',
          statusOk:true
        })
        setTimeout(() => {
          window.location.reload()
        }, 2000)
      })
      .catch((error) => {
        setFeedback({
          isOpen:true,
          message:'Falha ao salvar parâmetro',
          statusOk:false
        })
        console.log(error)
      })
  }

  return (
    <Container>
      <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
      <SaveButtonDiv 
        onClick={() => handleSubmit(repeatedName)}
        className={repeatedName || mainFields.name === '' ? 'disabled' : ''}
      >
          <SaveButtonImage src={save} alt='Right arrow icon'/>
          <SaveButtonText className='saveText'>Salvar norma</SaveButtonText>
      </SaveButtonDiv>
    </Container>
  )
}

export default AddParamButtonsDiv
